module.exports = __webpack_public_path__ + "static/media/MY-USM.751caf3c.png";